let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fJEq7")).then(() => parcelRequire('1JqFz'));